import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin, FaPhoneAlt, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { MdEmail } from 'react-icons/md';
import { SiGooglemaps } from 'react-icons/si';
import logo from '../assests/img/logo2.png';
import { contactInfo, footerColumns } from '../data/siteNav';
import '../assests/css/footer.css';

function FooterAccordion({ id, title, openId, onToggle, children, className = '' }) {
  const isOpen = openId === id;

  return (
    <div className={`eduya-footer-column ${className}${isOpen ? ' is-open' : ''}`}>
      <h3>
        <button
          type="button"
          aria-expanded={isOpen}
          aria-controls={`footer-panel-${id}`}
          onClick={() => onToggle(id)}
        >
          {title}
          <span className="eduya-footer-toggle" aria-hidden="true" />
        </button>
      </h3>
      <div className="eduya-footer-panel" id={`footer-panel-${id}`}>
        {children}
      </div>
    </div>
  );
}

function Footer() {
  const [openId, setOpenId] = useState(null);
  const { pathname } = useLocation();
  const showAddress = pathname !== '/privacy-policy';

  const toggle = (id) => {
    setOpenId((current) => (current === id ? null : id));
  };

  const renderLinks = (links) =>
    links.map((item) => (
      <li key={item.label}>
        <Link to={item.to}>{item.label}</Link>
      </li>
    ));

  return (
    <footer className="eduya-footer site-footer">
      <div className="container">
        <div className="eduya-footer-grid">
          <div className="eduya-footer-brand">
            <Link to="/" className="eduya-footer-logo">
              <img src={logo} alt="Bright Study" />
            </Link>
            <p>
              Connected school systems that help teams teach, operate, and grow with clarity.
            </p>
            <p className="eduya-footer-tagline">
              LEARN <span className="dot orange" /> EXPLORE <span className="dot green" /> GROW
            </p>
            <p className="eduya-footer-photo-credit">
              Photos from Unsplash, used under the Unsplash License.
            </p>
            <div className="eduya-footer-social">
              <a href="#" aria-label="Facebook"><FaFacebook /></a>
              <a href="#" aria-label="Instagram"><FaInstagram /></a>
              <a href="#" aria-label="LinkedIn"><FaLinkedin /></a>
              <a href="#" aria-label="X"><FaXTwitter /></a>
              <a href="#" aria-label="YouTube"><FaYoutube /></a>
            </div>
          </div>

          <FooterAccordion id="platforms" title="Platforms" openId={openId} onToggle={toggle}>
            <ul>{renderLinks(footerColumns.platforms)}</ul>
          </FooterAccordion>

          <FooterAccordion id="optimisation" title="School Optimisation" openId={openId} onToggle={toggle}>
            <ul>{renderLinks(footerColumns.optimisation)}</ul>
          </FooterAccordion>

          <FooterAccordion id="insights" title="Insights" openId={openId} onToggle={toggle}>
            <ul>{renderLinks(footerColumns.insights)}</ul>
          </FooterAccordion>

          <FooterAccordion
            id="contact"
            title="Get in touch"
            openId={openId}
            onToggle={toggle}
            className="eduya-footer-contact "
          >
            <ul>
              {showAddress ? (
                <li>
                  <SiGooglemaps />
                  <span>{contactInfo.address}</span>
                </li>
              ) : null}
              <li>
                <FaPhoneAlt />
                <a href={contactInfo.phoneHref}>{contactInfo.phone}</a>
              </li>
              <li>
                <MdEmail />
                <a href={contactInfo.emailHref}>{contactInfo.email}</a>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
            </ul>
            <Link to="/register-for-demo" className="eduya-cta eduya-cta-footer">
              Register for Demo
            </Link>
          </FooterAccordion>
        </div>
      </div>
      <div className="eduya-footer-copyright">
        <div className="container">
          <p>
            &copy; Copyright 2026 Brightstudy. All rights reserved.{' '}
            <Link to="/privacy-policy">Privacy Policy</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
